import React, { useEffect, useMemo, useState } from 'react';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import errorBlue from '../../../../../assets/icons/errorBlue.svg';
import maintenance from '../../../../../assets/icons/maintenance.svg';
import infoIcon from '../../../../../assets/icons/i.svg';
import devicesIcon from '../../../../../assets/icons/Devices.svg';
import checkGreen from '../../../../../assets/icons/checkGreen.svg';

import { title } from 'process';
import { IconButton } from '@mui/material';
import { useRouteContext } from 'packages/novous_web/src/context/RouteContext';
import { useAuth } from 'packages/novous_web/src/authContext/useAuth';
import useAxios from 'packages/novous_web/src/api/useAxios';
import { API_ENDPOINTS } from 'packages/novous_web/src/api/endpoints';
import { formatTime } from 'packages/novous_web/src/utils/helper';
import PermissionGuard from '../../../../../common/components/PermissionGuard';
import { PermissionSubcategory } from '../../../../../utils/permissionConstants';

type ColumnObjType = {
  [key: string]: {
    name: string;
    status: boolean;
  };
};

const DeviceDataTiles: React.FC<{ data: ColumnObjType | undefined }> = ({ data }) => {
  const { user } = useAuth();
  const [countData, setCountData] = useState<any>();

  let tripTilesData = [
    {
      icon: devicesIcon,
      heading: 'Total Devices',
      value: 0,
      permission: {
        category: PermissionSubcategory.DEVICES,
        subcategory: PermissionSubcategory.TOTAL_DEVICES,
      },
    },
    {
      icon: checkGreen,
      heading: 'Active Devices',
      value: 0,
      permission: {
        category: PermissionSubcategory.DEVICES,
        subcategory: PermissionSubcategory.ACTIVE_DEVICES,
      },
    },
    {
      icon: errorBlue,
      heading: 'Faulty Devices',
      value: 0,
      permission: {
        category: PermissionSubcategory.DEVICES,
        subcategory: PermissionSubcategory.FAULTY_DEVICES,
      },
    },
    {
      icon: maintenance,
      heading: 'Under Maintenance',
      value: 0,
      permission: {
        category: PermissionSubcategory.DEVICES,
        subcategory: PermissionSubcategory.MAINTENANCE_DEVICES,
      },
    },
  ];

  const {
    data: deviceTilesCount,
    error: deviceTilesError,
    loading: deviceTilesLoading,
    fetchData: fetchDeviceTilesCount,
  } = useAxios<any>(`${API_ENDPOINTS.directories.DEVICE_TILES_COUNT}`, 'POST');

  // Get filterData from window.history.state if available
  let filterDataFromLocation: any = { data: {}, isfiltered: false };
  if (window && window.history && window.history.state && window.history.state.usr && window.history.state.usr.filterData) {
    filterDataFromLocation = window.history.state.usr.filterData;
  }

  useEffect(() => {
    const payload: any = {
      fleetId: user.customer_id,
    };
    if (filterDataFromLocation.data?.vehicleGroup) {
      payload.vehicleGroup = filterDataFromLocation.data.vehicleGroup;
    }
    if (filterDataFromLocation.data?.deviceType) {
      payload.deviceType = filterDataFromLocation.data.deviceType;
    }
    fetchDeviceTilesCount(payload);
  }, [user, filterDataFromLocation]);

  useEffect(() => {
    setCountData(deviceTilesCount);
  }, [deviceTilesCount]);

  tripTilesData[3].value = countData?.data.unusedRoute || 0;
  tripTilesData[2].value = countData?.data.faultyDevices || 0;
  tripTilesData[1].value = countData?.data.totalDevicesByTypes || 0;
  tripTilesData[0].value = countData?.data.totalDevice || 0;

  const filteredTileData = useMemo(() => {
    return tripTilesData.filter((item, index) => {
      const stateName = 'Stat' + (index + 1);
      if (data) {
        if (data[stateName].name === item.heading) {
          return data[stateName].status;
        }
        return false;
      } else {
        return true;
      }
    });
  }, [data, tripTilesData]);

  return (
    <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {filteredTileData.map((tile, index) => (
        <PermissionGuard
          key={index}
          category={tile.permission.category}
          subcategory={tile.permission.subcategory}
        >
          <Paper
            sx={{ borderRadius: '12px' }}
            className="border border-[#f0eff8] p-4 flex flex-col gap-1 items-start"
          >
            <div className="flex items-center gap-2 w-full">
              <IconButton
                sx={(theme) => ({
                  background: theme.palette.selected,
                  padding: '0px',
                  borderRadius: '8px',
                })}
              >
                <img src={tile?.icon} alt="icon" color="primary" />
              </IconButton>
              <div className="flex flex-1 min-w-0 flex-col justify-start gap-1">
                <Typography
                  variant="body2"
                  noWrap // Ensures text doesn't wrap and remains in a single line
                  sx={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    maxWidth: '100%', // Ensures it adapts to available space
                  }}
                >
                  {tile.heading}
                </Typography>
              </div>

              <img src={infoIcon} alt="info icon" title="More info" className="w-4 h-4 cursor-pointer" />
            </div>
            <div className="flex items-center w-full gap-2 flex-nowrap">
              <div className="invisible w-6 h-6">{tile.icon}</div>
              <Typography
                variant="h6"
                fontWeight={600}
                className="flex-grow px-2 w-full whitespace-nowrap overflow-hidden text-ellipsis"
              >
                {tile.value}
              </Typography>
            </div>
          </Paper>
        </PermissionGuard>
      ))}
    </div>
  );
};

export default DeviceDataTiles;
